/* eslint-disable max-len */
import React from 'react';
import NavigationLinks from '../NavigationLinks';
import SocialIcons from '../SocialIcons';

import './styles.scss';

const Footer = () => {
  return (
    <div className="Footer">
      <div className='partner'>
        <p className='supported-by-text'>Supported by</p>
        <a href="https://www.visegradfund.org/" target="_blank" rel="noreferrer">
          <img src="/visegrad_fund_logo_black.png" height={50} alt="Visegrad Fund logo"/>
        </a>
      </div>

      <div className='flex-container'>
        <div className="copyright">
          <span>Made by <a href="https://ceias.eu" target="_blank" rel="noreferrer">CEIAS</a> in 2025</span>
        </div>
        <div className="navigation">
          <NavigationLinks/>
        </div>
      </div>
    </div>
  );
};

export default Footer;
